const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "";

export const buildApiUrl = (path: string) => `${API_BASE_URL}${path}`;
